// Format numbers with locale
export function fNumber(number: number | string): string {
  if (typeof number === 'string') {
    number = parseFloat(number)
  }

  if (isNaN(number)) {
    return '0'
  }

  return new Intl.NumberFormat('th-TH').format(number)
}

// Format currency in Thai Baht
export function fCurrency(amount: number | string): string {
  if (typeof amount === 'string') {
    amount = parseFloat(amount)
  }

  if (isNaN(amount)) {
    return '฿0'
  }

  return new Intl.NumberFormat('th-TH', {
    style: 'currency',
    currency: 'THB',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(amount)
}

// Format percentage
export function fPercent(number: number | string): string {
  if (typeof number === 'string') {
    number = parseFloat(number)
  }

  if (isNaN(number)) {
    return '0%'
  }

  return new Intl.NumberFormat('th-TH', {
    style: 'percent',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(number / 100)
}

// Format compact numbers (1K, 1M, etc.)
export function fShortenNumber(number: number | string): string {
  if (typeof number === 'string') {
    number = parseFloat(number)
  }

  if (isNaN(number)) {
    return '0'
  }

  return new Intl.NumberFormat('th-TH', {
    notation: 'compact',
    compactDisplay: 'short',
  }).format(number)
}
